import labels from "../../utils/labels";
import StandardButton from "../UI/buttons/StandardButton";
import Modal from "../UI/Modal";
import Overlay from "../UI/Overlay";
import Body2 from "../UI/textFields/Body2";
import Header2 from "../UI/textFields/Header2";

const UnsavedEmployeeEditsModal = ({
  onKeepEditing,
  onDiscard,
}: {
  onKeepEditing: () => void;
  onDiscard: () => void;
}) => {
  return (
    <Overlay darkBackground clickAway={onKeepEditing}>
      <Modal>
        <Header2>{labels.unsavedChanges}</Header2>
        <Body2>{labels.saveChangesWarningBody}</Body2>
        <div className="flex justify-end gap-[var(--spacing-sm)] w-full">
          <StandardButton
            variant="SECONDARY"
            onClick={onDiscard}
            ariaLabel={labels.discardAndCloseModal}
          >
            {labels.discardAndCloseModal}
          </StandardButton>
          <StandardButton
            variant="PRIMARY"
            onClick={onKeepEditing}
            ariaLabel={labels.saveAndCloseModal}
          >
            {labels.saveAndCloseModal}
          </StandardButton>
        </div>
      </Modal>
    </Overlay>
  );
};

export default UnsavedEmployeeEditsModal;
